import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
  after: z.string().optional(), // Message ID to fetch messages after
});

export type InputType = z.infer<typeof schema>;

export type ChatMessage = {
  id: string;
  sessionId: string;
  userId: number;
  personaId: string | null;
  message: string;
  createdAt: Date;
  user: {
    id: number;
    displayName: string;
    avatarUrl: string | null;
  };
  persona: {
    id: string;
    name: string;
    icon: string;
    category: string;
  } | null;
};

export type OutputType = {
  messages: ChatMessage[];
};

export const getChatMessages = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams();
  params.append('sessionId', input.sessionId);
  if (input.after) {
    params.append('after', input.after);
  }

  const result = await fetch(`/_api/chat/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
